const careerTreeResponse = `
\r* commit HEAD (HEAD -> career, origin/career, origin/HEAD)
\r\x1b[36m|\x1b[0m
\r* Position:  \x1b[33mEmbedded Software Engeineer (part time)\x1b[0m
\r\x1b[36m|\x1b[0m Company:   Pro-S Professional Solutions d.o.o.
\r\x1b[36m|\x1b[0m Period:    2024 (5 months)
\r\x1b[36m|\x1b[0m
\r\x1b[36m|\x1b[0m   Working on software for custom RP2040 based devices for
\r\x1b[36m|\x1b[0m   intercomunication between telemetry devices, and securing
\r\x1b[36m|\x1b[0m   the software from unauthorized device access.
\r\x1b[31m|\x1b[32m\\\x1b[0m
\r\x1b[31m|\x1b[32m |\x1b[0m
\r* \x1b[32m|\x1b[0m Position:  \x1b[33mFull stack software engineer (internship)\x1b[0m
\r\x1b[31m| \x1b[32m|\x1b[0m Company:   Value Shore d.o.o.
\r\x1b[31m| \x1b[32m|\x1b[0m Period:    2022-2023
\r\x1b[31m| \x1b[32m|\x1b[0m
\r\x1b[31m| \x1b[32m|\x1b[0m   Architecting and constructing RESTful Web APIs coupled with
\r\x1b[31m| \x1b[32m|\x1b[0m   single-page, responsive user interface design.
\r\x1b[31m| \x1b[32m|\x1b[0m
\r\x1b[31m| \x1b[32m|\x1b[0m
\r\x1b[31m| \x1b[0m*\x1b[0m Position:  \x1b[33mEmbedded Software Developer (part time)\x1b[0m
\r\x1b[31m|/\x1b[0m  Company:   ValueIT
\r\x1b[32m|\x1b[0m   Period:    2022 (4 months)
\r\x1b[32m|\x1b[0m   
\r\x1b[32m|\x1b[0m     Developing software for RP2040 Pico/Zero boards using MicroPython.
\r\x1b[32m|\x1b[0m
\r\x1b[32m|\x1b[0m
\r* Position:  \x1b[33mVoluntary work\x1b[0m
\r\x1b[32m|\x1b[0m Company:   Decode d.o.o.
\r\x1b[32m|\x1b[0m Period:    2017 (2 months)
\r\x1b[32m|\x1b[0m
\r\x1b[32m|\x1b[0m   Learning and calibrating GSM telemetry devices
\r:`;

const qr_code_linkedin = `\r\n\r\n█▀▀▀▀▀█ ▄ ▄▀▀▀ ▄█ █▀▀▀▀▀█\r\n█ ███ █ ▄█▀▀█▄█▀▀ █ ███ █\r\n█ ▀▀▀ █ ▄ ▄▀ ▀ ▄█ █ ▀▀▀ █\r\n▀▀▀▀▀▀▀ ▀ ▀ █ ▀ █ ▀▀▀▀▀▀▀\r\n███▀█▄▀███▀█▀▀▀  ▀ █ ▀▄▀ \r\n█▄█  █▀  █▄   ▄▀▄▄▀▄█▀▀██\r\n▄▄▄ ██▀█▀█▄█▀█▀ ▄▀▀ ▀██  \r\n█ ▄ ▄▀▀▄▄▀█ ▄ ▄█▀█ ▄█ ▀▀█\r\n▀  ▀▀▀▀ ████▀█▀▄█▀▀▀█▀▀▀ \r\n█▀▀▀▀▀█ ▀ █▄▄ ▀ █ ▀ █  ▀▀\r\n█ ███ █ █ ▄▄ █▀▀███▀█▀▀█▄\r\n█ ▀▀▀ █ █ █  ▀█▄█▄ █ ▀  █\r\n▀▀▀▀▀▀▀ ▀▀ ▀▀▀ ▀ ▀▀ ▀▀▀▀▀ `;
const qr_code_github = `\r\n\r\n█▀▀▀▀▀█ █  ▄▄▀▀▀▀ █▀▀▀▀▀█\r\n█ ███ █ ██▄ █▄█ ▄ █ ███ █\r\n█ ▀▀▀ █ ▄██ ▀█ ▀█ █ ▀▀▀ █\r\n▀▀▀▀▀▀▀ ▀ █▄▀ █▄▀ ▀▀▀▀▀▀▀\r\n▀█  ▀▀▀ ▄ ▀ ▀ ▄▄▄  ▀▄█▀█▀\r\n  █▀▄▄▀▄▀█▀ ▄▀▀█▀ ▀██▀█  \r\n█ ▀▀▄█▀ █ ▄▀▄▄▀▄▄ ▀▀▄ █  \r\n  ▄██ ▀▀ █▀█▀ ▄█▀ █▀▀▀█ ▄\r\n▀▀ ▀ ▀▀ █▄  ▀ █▀█▀▀▀██▀▀▀\r\n█▀▀▀▀▀█ ▄ ▄ ▄▀█ █ ▀ █ █▄▄\r\n█ ███ █ ▀ ▀▀▄▀█▄████▀ ▀██\r\n█ ▀▀▀ █ ▄▄██▀█▀▄ ▀▀▀▄█▄█ \r\n▀▀▀▀▀▀▀ ▀ ▀ ▀▀ ▀ ▀    ▀▀▀ `;
const qr_code_paypal = `\r\n\r\n█▀▀▀▀▀█ ▀▀▀█▄▀▄▀▄ █▀▀▀▀▀█\r\n█ ███ █  ▀▄█ █▀▄▄ █ ███ █\r\n█ ▀▀▀ █  ▄▀█▀▀▀ █ █ ▀▀▀ █\r\n▀▀▀▀▀▀▀ █▄▀ █▄▀ █ ▀▀▀▀▀▀▀\r\n▀▀▄▀▀▄▀▄ ▀▄ ▀▄█▄▀ ▀ ▄  ▄▀\r\n█ ▄  ▄▀▄▄▀  ▀ ▄▀█  █▀▄▄ █\r\n▄█ █▀█▀▄█▀█ ▄ ▄▄█ █▀▄  ▀▀\r\n█▀ ▀█▀▀▄ ▀  ▄▀ ▀▄█▄▄ ██▀█\r\n▀ ▀ ▀ ▀ █▀ █▀▀ ▀█▀▀▀█▀█▀▀\r\n█▀▀▀▀▀█  ▀█▄▀▄▀▄█ ▀ █▄▀ ▀\r\n█ ███ █ ███▀▄█▄▀███▀▀█ ██\r\n█ ▀▀▀ █ ▄ ▀█▄█ ▀▀█ ▀█▀▄██\r\n▀▀▀▀▀▀▀ ▀▀▀▀▀▀  ▀ ▀  ▀  ▀ `;
const qr_code_email = `\r\n\r\n█▀▀▀▀▀█ ▄█ ▄▄▀▄▄█ ▄▀▀ █▀▀▀▀▀█\r\n█ ███ █ ▄█▀█ ▄ ▀ ▄▀▀  █ ███ █\r\n█ ▀▀▀ █ ▄ █ ▀█▄▄██▀▀█ █ ▀▀▀ █\r\n▀▀▀▀▀▀▀ ▀ ▀ █ ▀▄▀ ▀ █ ▀▀▀▀▀▀▀\r\n█▀▀█▀ ▀▀▀█▀ ▀▀▀▀▄▀ ▄▄█▄█▄█▄█▄\r\n▀▄█▀▀▄▀███▄█▀▀▄██▀█▄█▀  ▀▄   \r\n    █ ▀ ▄█▄▀▄█▀ ▄▀ ▄█▄▄▄▄█▀██\r\n█▄▀ ██▀ █ █ ▄▀█▀█ ▄▄ ▀▀▀▀▄   \r\n▄▄▄ ▄▄▀▄▀   ▀█▀▀▄▀▄ ▄▄▄▄▄▄██▄\r\n█  ▄ ▀▀▄▄▄ █▀ ██ ▀▄▄ ▄▀█▀▀▀  \r\n▀  ▀▀▀▀ ▄▄▄▀▄▄ █▄█▄▄█▀▀▀█▀█▄█\r\n█▀▀▀▀▀█ ▀▀▀ ▄█▀▀█▀ ▀█ ▀ █▄▀  \r\n█ ███ █ ██▀ ▀ ▀ ▄█▄▄▀▀▀▀▀▀▀██\r\n█ ▀▀▀ █ █▀▄█▀ ▄█▀ ▄▀▄▀████▀█ \r\n▀▀▀▀▀▀▀ ▀▀ ▀     ▀    ▀   ▀  `;

export const responseCommands = {
  whoami:
    "\r\nMy Name: Mihailo Simić\r\nRole: Software Engineer\r\nOther Interests: Cybersecurity, Networks and IoT",
  career_list:
    "\r\nEmbedded Software Developer -> Full Stack Egineer -> Embedded Software Engineer",
  career_tree: `${careerTreeResponse}`,
  qr_linkedin: `${qr_code_linkedin}`,
  qr_github: `${qr_code_github}`,
  qr_paypal: `${qr_code_paypal}`,
  qr_email: `${qr_code_email}`,
  contact:
    "\r\nEmail: simihailo@gmail.com\r\nTel: +381 69 22 11 407\r\nLinkedIn: linkedin.com/in/mihailo-simic/",
  info: "\r\nINFO ABOUT THIS PAGE AND/OR USER EXPERIENCE",
  help: `\r\nCommon prompts:
              \r\n\twhoami : Get personal info
              \r\n\tcontact : Get contact info
              \r\n\tcareer [option] : Show career path
              \r\n\t\t-l : Show steps in list-like path
              \r\n\t\t-t : Show steps in tree
              \r\n\tget [option] : Downloads the resource specified
              \r\n\t\t--cv : Downloads my CV in pdf format
              \r\n\t\t--github : Checkout my GitHub page
              \r\n\t\t--vcard : Get my personal Vcard
              \r\n\tqr [option] : Generate my personalized qr codes
              \r\n\t\t--email : My email address for quick send :)
              \r\n\t\t--linkedin : Direct acces to my LinkedIn page
              \r\n\t\t--paypal : My PayPal account
              \r\n\treboot [option] : Schedules the app rebot
              \r\n\t\t--now : Reboots immediately
              \r\n\t\t--time <num> : Schedule reboot in <num> seconds
              \r\n\tshutdown : Shuts down the app
              \r\n\thelp:\tShows this help message
              \r\n\thistory : Print out terminal history
              \r\n\tinfo :\tShows the general info about this terminal
              \r\n\texit : \tClose this terminal window
              \r\n\tclear : Clear the terminal window`,
  ANSI_ART: [
    " _    _      _                          _",
    "\r\n| |  | |    | |                        | |",
    "\r\n| |  | | ___| | ___ ___  _ __ ___   ___| |",
    "\r\n| |/\\| |/ _ \\ |/ __/ _ \\| '_ ' _ \\ / _ \\ |",
    "\r\n\\  /\\  /  __/ | (_| (_) | | | | | |  __/_|",
    "\r\n \\/  \\/ \\___|_|\\___\\___/|_| |_| |_|\\___(_)\r\n",
    "\r\n*** Type 'help' start journey ***",
  ],
};
